import React, { useEffect } from "react"
import FooterComponent from "../../components/footer"
import ReactHelmet from "src/components/react-helmet"

const RegalRoad = () => {
  useEffect(() => {
    try {
      var script = document.createElement("script")
      script.src = "https://paperform.co/__embed"
      script.async = true
      document.body.appendChild(script)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <>
      <ReactHelmet
        url="toronto-regal-road-2"
        title="Toronto Regal Road"
        description="Tolobi - Rental Made Easy"
      />
      <div data-paperform-id="starlight-toronto-rr2"></div>
      <FooterComponent />
    </>
  )
}

export default RegalRoad
